import { useEffect, useState } from "react";
import { api, fmtDate } from "@/lib/api";
import { PageHead } from "@/pages/admin/AdminLayout";
import { Table } from "@/pages/admin/Payments";

export default function Messages() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/admin/messages").then((r) => setRows(r.data));
  }, []);
  return (
    <div data-testid="admin-messages">
      <PageHead title="Contact messages" />
      <Table head={["Received", "Name", "Email", "Phone", "Message"]} testid="messages-table">
        {rows.map((m) => (
          <tr key={m.id} className="border-b border-white/5 align-top">
            <td className="px-4 py-3 text-slate-400 whitespace-nowrap">{fmtDate(m.created_at)}</td>
            <td className="px-4 py-3">{m.name}</td>
            <td className="px-4 py-3">{m.email}</td>
            <td className="px-4 py-3">{m.phone || "—"}</td>
            <td className="px-4 py-3 text-slate-300 max-w-md whitespace-pre-wrap">{m.message}</td>
          </tr>
        ))}
      </Table>
    </div>
  );
}
